<template>
  <ValidationProvider tag="div" :rules="rules" :name="name" :vid="vid" v-slot="{ errors }" :mode="customMode">
    <div ref="textarea">
      <textarea-autosize
        v-model="currentValue"
        :min-height="calcMinHeight"
        :max-height="calcMaxHeight"
        :rows="rows"
        :class="[
          inputClass,
          {
            'is-invalid': errors.length,
          },
        ]"
        :disabled="disabled"
      />
    </div>
    <b-tooltip :target="() => $refs['textarea']" :title="errors.length ? errors[0] : null" variant="danger" noninteractive placement="top" boundary="window"></b-tooltip>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { BTooltip } from "bootstrap-vue";

export default {
  name: "InputTextArea",
  components: {
    ValidationProvider,
    BTooltip,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: undefined,
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    inputClass: {
      type: String,
      default: "form-control form-control-sm",
    },
    maxHeight: {
      type: Number,
      default: 42,
    },
    rows: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      disabled: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  computed: {
    calcMinHeight() {
      return this.rows * 21;
    },
    calcMaxHeight() {
      return this.rows * 21;
    },
  },
  watch: {
    currentValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    customMode({ errors }) {
      if (errors.length) {
        return {
          on: ["input", "change.native"],
        };
      }

      return {
        on: ["change.native", "blur.native"],
      };
    },
  },
};
</script>
